/**
 *
 * Records Page
 *
 */
import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Label,
  // Table,
  FormGroup,
  Input,
  Button,
  Spinner,
  Card,
  CardBody,
} from "reactstrap"
import Modal from "react-bootstrap/Modal"
import { withRouter, useParams } from "react-router-dom"
import ButtonSpinner from "../../components/ButtonSpinner"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as employeeAction from "../../store/RW1wbG95ZWVSZXF1ZXN0/actions"
import { useSelector, useDispatch } from "react-redux"
import Select from "react-select"
import { isEmpty } from "lodash"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { ToastContainer, toast } from "react-toastify"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit"

//Import Styles
import "./styles.scss"
import moment from "moment"

const EmployeeRequest = (props) => {
  const { dispatch, searchBarStyle } = props
  const specificDispatch = useDispatch()
  let { id } = useParams()
  const { SearchBar } = Search


  const mode = "hrms"

  const { ExportCSVButton } = CSVExport

  useEffect(() => {
    dispatch(employeeAction.loadEmployeeRequest())
    dispatch(employeeAction.loadRecordsMetaData())
    dispatch(employeeAction.loadProcessStatus(mode))
   
  }, [])


  const employeeUpdate = useSelector(
    (specificstate) => specificstate.employeeRequest
  )
  const {
    employee_request = [],
    recordsMetaData = {},
    process_status = [],
  } = employeeUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate


  const salesManagerId = !isEmpty(user) && user.roleId
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""


  const [btnLoader, setBtnLoader] = useState(false)
  const [processRequest, setProcessRequest] = useState(false)
  const handleProcess = () => setProcessRequest(false)

  const [employeeData, setEmployeeData] = useState({
    companyid: id,
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    responseStatus: [],
  })

  const handleChange = (e) => {
    setEmployeeData({ ...employeeData, [e.target.name]: e.target.value })
  }

  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [process, setProcess] = useState([])
  const [designation, setDesignation] = useState([])

  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )
  const designationOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.designationOptions.filter(
      (designation) => designation.departmentId === departmentList.value
    )

  const processStatusList =
    !isEmpty(process_status) &&
    process_status.map((process) => {
      return {
        _id: process._id,
        colorCode: process.colorCode,
        description: process.description,
        mode: process.mode,
        processStatus: process.processStatus,
        processStatusId: process.processStatusId,
        shortCode: process.shortCode,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
          ; (obj.value = element._id),
            (obj.label = element.processStatus),
            (obj.colorCode = element.colorCode),
            (obj.mode = element.mode),
            (obj.processStatusId = element.processStatusId),
            options.push(obj)
      })
    return options
  }

  const processStatusOptions = createOptions(processStatusList)


  const [requestModal, setRequestModal] = useState(false)
  const [requestData, setRequestData] = useState({
    company: "",
    branch: "",
    designation: "",
    department: "",
    requestDate: "",
    subject: "",
    reason: ""

  })
  const handleRequestChange = (e) => {
    setRequestData({ ...requestData, [e.target.name]: e.target.value })
  }
  const [empCodeData, setEmpCodeData] = useState([])
  const employeeChange = (e) => {
    setEmpCodeData(e)

    requestData.company = e ? e.companyName : ""
    requestData.branch = e ? e.branchName : ""
    requestData.department = e ? e.departmentName : ""
    requestData.designation = e ? e.designationName : ""

    setRequestData(requestData)
  }
  const clearEmployeeChange = () => {
    setEmpCodeData([])
    setRequestData({
      ...requestData,
      company: "",
      branch: "",
      designation: "",
      department: "",
    })
  }
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const handleRequestModal = () => {
    setRequestModal(false)
  }
  const clearRequest = () => {
    setRequestData({
      company: "",
      branch: "",
      designation: "",
      department: "",
      requestDate: "",
      subject: "",
      reason: ""
    })
  }
  const [confirmModalView, setConfirmModalView] = useState(false)
  const handleConfirmModal = () => setConfirmModalView(false)
  const [searchValue, setSearchValue] = useState("")

  const searchValueList = !isEmpty(searchValue) ? searchValue : {}
  const handleApply = (e) => {
    e.preventDefault()
    // const processStatus = process.processStatusId
    var searchCompany = companies && companies.value ? [companies.value] : ""
    var searchBranch = branches && branches.value ? [branches.value] : ""
    var searchDepartment =
      departmentList && departmentList.value ? [departmentList.value] : ""
    var searchProcess =
      process && process.label ? process.label : ""
    var searchDesignation =
      designation && designation.value ? [designation.value] : ""
    var searchFromDate =
      employeeData && employeeData.fromDate ? employeeData.fromDate : ""
    var searchToDate =
      employeeData && employeeData.toDate ? employeeData.toDate : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.company = searchCompany
    }
    if (searchBranch) {
      searchvalue.branch = searchBranch
    }
    if (searchDepartment) {
      searchvalue.department = searchDepartment
    }
    if (searchDesignation) {
      searchvalue.designation = searchDesignation
    }
    if (searchProcess) {
      searchvalue.requestStatus = searchProcess
    }
    if (searchFromDate) {
      searchvalue.startDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.endDate = searchToDate
    }
    setSearchValue(searchvalue)

    specificDispatch(employeeAction.loadEmployeeRequest(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }


  const resetFormDetails = () => {
    // e.preventDefault()
    setDepartmentList([])
    setProcess([])
    setCompanies([])
    setBranches([])
    setDesignation([])
    setEmployeeData({
      fromDate: "",
      toDate: "",
    })
    dispatch(employeeAction.loadEmployeeRequest())
  }

  //Update section
  

  const [requestId, setRequestId] = useState("")
  const [isLoading, setIsLoading] = useState("")
  const [requestNo, setRequestNo] = useState("")
  const [requestStatus, setRequestStatus] = useState("")

  let slNo = 0
  const employeeDataTable = !isEmpty(employee_request)
    ? employee_request.map((employee, index) => {
      slNo = slNo + 1

      const appliedDate =
        !isEmpty(employee) && employee.createdAt
          ? moment(employee.createdAt)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(`${dateFormate} hh:mm A`)
          : "--"
      return {
        _id: employee._id,
        sNo: slNo,
        reponseNotes: employee.ReponseNotes ? employee.ReponseNotes : "--",
        branchId: employee.branchId,
        branchName: employee.branchName,
        companyId: employee.companyId,
        companyName: employee.companyName,
        departmentId: employee.departmentId,
        appliedDate: appliedDate,
        departmentName: employee.departmentName,
        description: employee.description,
        designationId: employee.designationId,
        designationName: employee.designationName,
        employeeCode: employee.employeeCode,
        employeeName: employee.employeeName,
        requestNo: employee.requestNo,
        requestStatus: employee.requestStatus,
        responseEmployeeCode: employee.responseEmployeeName,
        responseEmployeeName: employee.responseEmployeeName,
        responseBy: employee.responseEmployeeName?
          employee.responseEmployeeName + "-" + employee.responseEmployeeCode:"--"
        , 
        subject: employee.subject,
        key: index,
        requestDate:employee.requestDate?moment(employee.requestDate).format(dateFormate):"--"
      }
    })
    : []


  // const [submittedResponse, setSubmittedResponse] = useState(true)

  const updateProcessStatus = createOptions(processStatusList)

  const updateProcessStatusOptions =
    !isEmpty(updateProcessStatus) &&
    updateProcessStatus.filter((process) => {
      return process.label !== requestStatus
    })


  const [updateProcess, setUpdateProcess] = useState([])
  const [updateData, setUpdateData] = useState({
    responseNotes: "",
    responseStatus: [],
  })

  const updateChange = (e) => {
    setUpdateData({ ...updateData, [e.target.name]: e.target.value })
  }


  const editEmployeeDetails = (employee) => {
    setUpdateProcess({ label: employee.requestStatus, value: "" })
    setUpdateData({
      ...updateData,
      responseNotes: employee.ReponseNotes,
      responseStatus: [{ label: employee.requestStatus, value: "" }],
    })
  }

  const updateEmployee = () => {
    const employeeUpdate = {
      requestId: requestId,
      responseNotes: updateData.responseNotes,
      status: updateProcess.processStatusId,
      responsedBy: salesManagerId,
    }
    specificDispatch(employeeAction.updateEmployeeRequest(employeeUpdate))
    setIsLoading(true)
    setTimeout(() => {
      setProcessRequest(false)
      specificDispatch(employeeAction.loadEmployeeRequest(searchValueList))
      setIsLoading(false)
      // setSubmittedResponse(true)
    }, 2000)
  }

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "requestNo",
      text: "Request No",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "employeeCode",
      text: "Code",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "departmentName",
      text: "Department",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "subject",
      text: "Subject",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "description",
      text: "Remarks",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "requestStatus",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <Button
            type="submit"
            className={
              row.requestStatus === "Accepted"
                ? "btn btn-success disabled-button"
                : "btn btn-warning"
            }
            onClick={() => {
              setProcessRequest(true)
              setRequestId(row._id)
              setRequestNo(row.requestNo)
              setRequestStatus(row.requestStatus)
              editEmployeeDetails(row)
            }}
            style={{ width: "80px", padding: "3px 5px" }}
          >
            {row.requestStatus}
          </Button>
        )
      },
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "requestDate",
      text: "Request Date",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "reponseNotes",
      text: "Response Remarks",
      sort: true,
      headerStyle: {
        minWidth: "175px",
      },
    },
    {
      dataField: "responseBy",
      text: "Responsed By",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "appliedDate",
      text: "Applied Date",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
  ]

  const title = "Employee Request"
  const options = {
    sizePerPage: 10,
    totalSize: employeeDataTable.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "<",
    nextPageText: ">",
    lastPageText: ">>",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const addEmployeeRequest = () =>{
    const date = requestData.requestDate?moment(requestData.requestDate).format("YYYY-MM-DD"):""
    const request_details = {
      "empcode":empCodeData.code,   
      "description": requestData.reason,
      "subject": requestData.subject,
      "requestDate":date
    }
    dispatch(employeeAction.addRequest(request_details))
    setTimeout(()=>{
      dispatch(employeeAction.loadEmployeeRequest())
      toast.success("Employee Request Added successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    },1000)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"HRMS"} breadcrumbItem={title} />
          <Row>
            <Col lg="12" md="12" sm="12" xs="12" className="mb-4">
              <div className="filter-buttons" style={{ float: "right" }}>
                <Button
                  style={{
                    backgroundColor: "#E40D8C",
                    color: "#ffffff",
                    border: "none",
                    marginTop: "-20px",
                  }}
                  onClick={() => {
                    setRequestModal(true)
                    clearRequest()
                  }}
                >
                  Add Employee Request
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              lg="12"
              md="12"
              sm="12"
              xs="12"
              className="employee-request-card"
              style={{ paddingRight: "18px" }}
            >
              <Card>
                <CardBody>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          classNamePrefix="select2-selection"
                          placeholder="Select Company"
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                          options={branchOptions}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Department"}
                          >
                            {"Department"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="department"
                          value={departmentList}
                          onChange={(e) => setDepartmentList(e)}
                          placeholder="Select Department"
                          classNamePrefix="select2-selection"
                          options={
                            recordsMetaData
                              ? recordsMetaData.departmentOptions
                              : []
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Response status"}
                          >
                            {"Designation"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="designation"
                          value={designation}
                          onChange={(e) => setDesignation(e)}
                          placeholder="Select Designation"
                          classNamePrefix="select2-selection"
                          options={designationOptions}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">From Date</Label>
                      <Input
                        type="date"
                        name="fromDate"
                        value={employeeData.fromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Select Date"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">To Date</Label>
                      <Input
                        type="date"
                        name="toDate"
                        value={employeeData.toDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Select Date"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Response status"}
                          >
                            {"Response status"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="process"
                          value={process}
                          onChange={(e) => setProcess(e)}
                          placeholder="Select Response Status"
                          classNamePrefix="select2-selection"
                          options={processStatusOptions}
                        />
                      </FormGroup>
                    </Col>
                    <Col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      className="filter-section mt-1"
                    >
                      <div className="filter-buttons">
                        <button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success btn-label"
                          onClick={(e) => handleApply(e)}
                        >
                          <i
                            className="mx-2 bx bx-filter-alt label-icon"
                            style={{ fontSize: "12px" }}
                          ></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Col className="employee-request1-card">
            <Row>
              <Col md="12" lg="12" xl="12" className="h-100 mt-3 mb-3">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(options)}
                      keyField="_id"
                      columns={columns}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          data={employeeDataTable}
                          columns={columns}
                          search
                        >
                          {(props) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row  ">
                                  <Col className="mb-3" md="4">
                                    <div className="d-flex flex-row ">
                                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <div
                                          className="position-relative mt-7"
                                          style={searchBarStyle || null}
                                        >
                                          <SearchBar {...props.searchProps} />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </div>{" "}
                                  </Col>
                                  <Col>
                                    <ExportCSVButton
                                      className="border float-right mx-10"
                                      style={{
                                        float: "right",
                                        backgroundColor: "#e40d8c",
                                        color: "#ffffff",
                                      }}
                                      {...props.csvProps}
                                    >
                                      Download{" "}
                                    </ExportCSVButton>{" "}
                                  </Col>

                                  <Col>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      responsive
                                      striped={true}
                                      bordered={true}
                                      keyField="_id"
                                      columns={columns}
                                      //  filter={ filterFactory() }
                                      // expandRow={expandRow}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>

                {processRequest && (
                  <Modal show={processRequest} onHide={handleProcess}>
                    <Modal.Header
                      style={{
                        backgroundColor: "#E40D8C",
                        color: "white",
                        minHeight: "65px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      <div className="d-flex flex-row">
                        <span>REQUEST NO:</span>
                        <h1 className="request-header">{requestNo}</h1>
                      </div>
                    </Modal.Header>
                    <Modal.Body>
                      <Col>
                        <Row className="d-flex flex-column">
                          <Col
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            className="d-flex flex-column"
                          >
                            <Label className="employee-label">
                              Response Notes
                            </Label>
                            <textarea
                              type="text"
                              name="responseNotes"
                              value={updateData.responseNotes}
                              onChange={(e) => updateChange(e)}
                              placeholder="Enter Response Notes"
                              className="employee-crowd-textarea"
                            />
                          </Col>
                          <Col
                            xl="6"
                            lg="6"
                            md="6"
                            sm="12"
                            xs="12"
                            className="mt-2"
                          >
                            <Label className="event-label">
                              Response Status
                            </Label>
                            <Select
                              type="text"
                              name="updateProcess"
                              value={updateProcess}
                              options={updateProcessStatusOptions}
                              onChange={(e) => setUpdateProcess(e)}
                              placeholder="Select Response Status"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="btn btn-danger"
                        onClick={handleProcess}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        className="btn btn-success"
                        onClick={() => {
                          handleProcess()
                          updateEmployee()
                        }}
                      >
                        Submit
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
              </Col>
              {isLoading ? (
                <Modal
                  show={isLoading}
                  style={{ width: "10%", margin: "20% 50%" }}
                >
                  <Modal.Body>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                      variant="success"
                      className="mx-2"
                    />
                    <span>Loading...</span>
                    {/* <span>Response Successfully Updated</span> */}
                  </Modal.Body>
                </Modal>
              ) : (
                ""
              )}

              {requestModal && (
                <Modal
                  show={requestModal}
                  onHide={handleRequestModal}
                  size="lg"
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <Col
                      xl="6"
                      lg="6"
                      md="6"
                      sm="6"
                      xs="6"
                      className="d-flex flex-row"
                    >
                      <span>Add Employee Request </span>
                    </Col>

                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="">
                        <Label className="employee-label">Employee Code</Label>
                        <ReactSearchAutocomplete
                          name="empCodeData"
                          items={recordsMetaData.employeeOptions}
                          value={empCodeData}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => employeeChange(e)}
                          onChange={(e) => employeeChange(e.target.value)}
                          onClear={(e) => clearEmployeeChange(e)}
                          placeholder="Enter Employee Code"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>{" "}
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Company</Label>
                        <Input
                          name="company"
                          value={requestData.company}
                          onChange={(e) => handleRequestChange(e)}
                          placeholder="Enter Company"
                          disabled
                          className="disabled-button"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Branch</Label>
                        <Input
                          name="branch"
                          value={requestData.branch}
                          disabled
                          onChange={(e) => handleRequestChange(e)}
                          placeholder="Enter Branch"
                          className="disabled-button"
                        />
                      </Col>
                      <Col
                        xl="3"
                        lg="3"
                        md="3"
                        sm="3"
                        xs="3"
                        className="d-flex flex-column"
                      >
                        <Label className="employee-label">Department</Label>
                        <Input
                          name="department"
                          value={requestData.department}
                          disabled
                          onChange={(e) => handleRequestChange(e)}
                          placeholder="Enter Department"
                        />
                      </Col>
                      <Col
                        xl="12"
                        lg="12"
                        md="12"
                        sm="3"
                        xs="3"
                        className="mt-2 mb-2"
                      >
                        <Row>
                          <Col
                            xl="3"
                            lg="3"
                            md="3"
                            sm="3"
                            xs="3"
                            className="d-flex flex-column"
                          >
                            {" "}
                            <Label className="employee-label">
                              Designation
                            </Label>
                            <Input
                              name="designation"
                              value={requestData.designation}
                              disabled
                              onChange={(e) => handleRequestChange(e)}
                              placeholder="Enter Designation"
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xl="3" lg="3" md="3" sm="3" xs="12" className="mt-2">
                        <Label className="employee-label">Request Date</Label>
                        <Input
                          type="date"
                          name="requestDate"
                          value={requestData.requestDate}
                          onChange={(e) => handleRequestChange(e)}

                        />
                      </Col>

                      <Col xl="3" lg="3" md="3" sm="6" xs="12" className="mt-2">
                        {" "}
                        <Label className="employee-label">Subject</Label>
                        <Input
                          type="text"
                          name="subject"
                          value={requestData.subject}
                          onChange={(e) => handleRequestChange(e)}
                          // disabled
                          placeholder="Enter Subject"

                        />
                      </Col>
                      <Col xl="6" lg="6" md="6" sm="12" xs="12" className="mt-2">
                        {" "}
                        <Label className="employee-label">Reason</Label>
                        <Input
                          type="textarea"
                          name="reason"
                          value={requestData.reason}
                          onChange={(e) => handleRequestChange(e)}
                          // disabled
                          placeholder="Enter Reason"

                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleRequestModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        setConfirmModalView(true)
                        handleRequestModal()
                      }}
                    >
                      Submit
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
                {confirmModalView && (
                <Modal
                  show={confirmModalView}
                  onHide={handleConfirmModal}
                  style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
                >
                  <Modal.Header
                    style={{
                      backgroundColor: "#E40D8C",
                      color: "white",
                      minHeight: "65px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    <div className="d-flex flex-row">
                      <span>Employee Request</span>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure, you want to add employee request?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      className="btn btn-danger"
                      onClick={handleConfirmModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      className="btn btn-success"
                      onClick={() => {
                        handleConfirmModal()
                        addEmployeeRequest()
                      }}
                    >
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            </Row>
          </Col>
          <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        </Container>
      </div>
    </React.Fragment>
  )
}

EmployeeRequest.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  employee_request: PropTypes.array,
  process_status: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapStateToProps = (state) => ({
  employee_request: state.employeeRequest.employee_request,
  process_status: state.employeeRequest.process_status,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmployeeRequest)
)
